import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter,
  Input,
  Output
} from "@angular/core";
import {IntFieldBoxComponent} from "../field";
import {TVerticalAlign} from "../../../types";


@Component({
  selector: 'int-labeled-field-box',
  templateUrl: './int-labeled-field-box.component.html',
  styleUrls: ['./vars.scss', './int-labeled-field-box.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class IntLabeledFieldBoxComponent extends IntFieldBoxComponent {

  @Input() label: string | null = '';
  @Input() isActive = false;
  @Input() showLabelTip = true;
  @Input() hideField = false;
  @Input() direction: string | null = 'ltr';
  @Input() verticalAlign: TVerticalAlign = 'center';
  @Input() isLabelBox: boolean | null = true;

  @Output() onContentTap = new EventEmitter();

  constructor(
    public cdr: ChangeDetectorRef,
    readonly elementRef: ElementRef
  ) {
    super(cdr, elementRef);
  }

  get vAlignValue() {
    return `v-align--${this.verticalAlign}`;
  }

  onContentClick() {
    this.onContentTap.emit();
  }

  setPseudoFocus() {
    this.isActive = true;
    this.cdr.markForCheck();
  }
}
